import React, { Component } from 'react';
import * as ajax from './../../ajax.js';
import * as lang from './../../lang.js';

import PopUpWindow from './../../components/PopUpWindow';
import { Container, Row, Col, Button } from 'react-bootstrap';

import TextAreaInsertField from './../../components/TextAreaInsertField';
import TextInsertField from './../../components/TextInsertField';
import DateInsertField from './../../components/DateInsertField';
import NumberInsertField from './../../components/NumberInsertField';
import CheckBoxInsertField from './../../components/CheckBoxInsertField';


class AutokView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            autok_id: ''
            , autok_rendszam: ''
            , autok_megjegyzes: ''
            , autok_tipus: ''
            , autok_muszaki_ervenyes: ''
            , autok_szemelyek_szama: ''
            , autok_elerheto: ''
            , autok_aktiv: ''

        }


        this.references = [];
        this.references['autok_id'] = React.createRef();
        this.references['autok_rendszam'] = React.createRef();
        this.references['autok_megjegyzes'] = React.createRef();
        this.references['autok_tipus'] = React.createRef();
        this.references['autok_muszaki_ervenyes'] = React.createRef();
        this.references['autok_szemelyek_szama'] = React.createRef();
        this.references['autok_elerheto'] = React.createRef();
        this.references['autok_aktiv'] = React.createRef();


        this.validators = [];
        this.validators['autok_id'] = {fieldName: 'autok_id', dataType: 'INT', value: this.state.autok_id, mandatory: false, min: null, max: null};
        this.validators['autok_rendszam'] = {fieldName: 'autok_rendszam', dataType: 'VARCHAR', value: this.state.autok_rendszam, mandatory: false, min: null, max: null};
        this.validators['autok_megjegyzes'] = {fieldName: 'autok_megjegyzes', dataType: 'VARCHAR', value: this.state.autok_megjegyzes, mandatory: false, min: null, max: null};
        this.validators['autok_tipus'] = {fieldName: 'autok_tipus', dataType: 'VARCHAR', value: this.state.autok_tipus, mandatory: false, min: null, max: null};
        this.validators['autok_muszaki_ervenyes'] = {fieldName: 'autok_muszaki_ervenyes', dataType: 'DATE', value: this.state.autok_muszaki_ervenyes, mandatory: false, min: null, max: null};
        this.validators['autok_szemelyek_szama'] = {fieldName: 'autok_szemelyek_szama', dataType: 'INT', value: this.state.autok_szemelyek_szama, mandatory: false, min: null, max: null};
        this.validators['autok_elerheto'] = {fieldName: 'autok_elerheto', dataType: 'TINYINT', value: this.state.autok_elerheto, mandatory: false, min: null, max: null};
        this.validators['autok_aktiv'] = {fieldName: 'autok_aktiv', dataType: 'TINYINT', value: this.state.autok_aktiv, mandatory: false, min: null, max: null};


        this.error = false;
        this.msg = "";

        this.load();

    }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.load();
        }
    }

    reset = function () {
        this.setState({autok_id: ''
            , autok_rendszam: ''
            , autok_megjegyzes: ''
            , autok_tipus: ''
            , autok_muszaki_ervenyes: ''
            , autok_szemelyek_szama: ''
            , autok_elerheto: ''
            , autok_aktiv: ''
        });
    }

    setBack = function (id, value) {
        this.setState({[id]: value});
    }

    getForm = function () {
        return <Container>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('autok_id')}</Col>
                <Col style={{textAlign: 'right'}}>
                <TextInsertField 
                    id={'autok_id'} 
                    value={this.state.autok_id}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['autok_id']}
                    editable={false}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('autok_rendszam')}</Col>
                <Col style={{textAlign: 'right'}}>
                <TextInsertField 
                    id={'autok_rendszam'} 
                    value={this.state.autok_rendszam}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['autok_rendszam']}
                    editable={false}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('autok_tipus')}</Col>
                <Col style={{textAlign: 'right'}}>
                <TextInsertField 
                    id={'autok_tipus'} 
                    value={this.state.autok_tipus}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['autok_tipus']}
                    editable={false}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('autok_muszaki_ervenyes')}</Col>
                <Col style={{textAlign: 'right',display:'contents'}}>
                <DateInsertField 
                    id={'autok_muszaki_ervenyes'} 
                    value={this.state.autok_muszaki_ervenyes}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['autok_muszaki_ervenyes']}
                    editable={false}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('autok_szemelyek_szama')}</Col>
                <Col style={{textAlign: 'right'}}>
                <NumberInsertField 
                    id={'autok_szemelyek_szama'} 
                    value={this.state.autok_szemelyek_szama}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['autok_szemelyek_szama']}
                    editable={false}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('autok_aktiv')}</Col>
                <Col style={{textAlign: 'right'}}>
                <CheckBoxInsertField 
                    id={'autok_aktiv'} 
                    value={this.state.autok_aktiv}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['autok_aktiv']}
                    editable={false}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('autok_megjegyzes')}:</Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left',whiteSpace:'break-spaces'}}>
                {this.state.autok_megjegyzes}
                
                </Col>
            </Row>
        </Container>
    }

    closeForm = function () {
        this.reset();
        this.props.closeForm();

    }

    transactionSuccess = function () {
        this.error = false;
        this.msg = lang.getTitleBold('transaction_success');
        this.setState({});
    }

    transactionFail = function (errorStringConstant) {
        this.error = true;
        this.msg = lang.getTitleBold(errorStringConstant);
        this.setState({});
    }

    concatAdditionalParams = function () {
        // var stateClone = JSON.parse(JSON.stringify(this.state));
        if (typeof this.props.additionalParams == 'undefined') {
            return this.state;
        }

        if (this.props.additionalParams == null) {
            return this.state;
        }

        var additionalParams = this.props.additionalParams;
        for (var i = 0; i < additionalParams.length; i++) {
            var additionalParam = additionalParams[i];
            for (const property in additionalParam) {
                this.state[property] = additionalParam[property];
            }
        }
        return this.state;
    }

    

    load = function () {
        var validator = ajax.Validator();
        var validForm = validator.formValidator(this.references, this.validators, this.state);
        if (validForm == false) {
            return false;
        }
        var self = this;
        try {
            const url = ajax.getUrlBase() + "modules/Autok/autokFormLoader.php";

            return fetch(url, {
                method: "POST",
                headers: new Headers({"Content-Type": "application/json"}),
                body: JSON.stringify({id: this.props.id})
            }).then(response => {
                if (response.ok) {
                    return response.json().then(response => {
                        if (response.success) {
                            this.setState(response.data[0]);
                        } else {
                            self.transactionFail(response.fail);
                        }

                    }).catch(function (jsonError) {
                        
                        if (null == jsonError) {
                            self.transactionFail('Fetch JSON error');
                            console.error("Fetch JSON error:");
                        } else {
                            self.transactionFail("Fetch JSON error:" + String(jsonError));
                            console.error("Fetch JSON error:" + String(jsonError));
                        }
                    });
                } else {
                    
                    self.transactionFail("HTTP status error:", response.statusText);
                    console.error("HTTP status error:", response.statusText);
                }
            }).catch(function (error) {
                
                self.transactionFail("Fetch error:", error);
                console.error("Fetch error:", error);
                if (null == error) {
                    self.transactionFail("Fetch error:");
                    console.error("Fetch error:");
                } else {
                    self.transactionFail("Fetch error:" + String(error));
                    console.error("Fetch error:" + String(error));
                }
            });
        } catch (ex) {
            
            self.transactionFail("Fetch exception:", String(ex));
            console.error("Fetch exception:", String(ex));
        }
    }

    render() {
        var form = this.getForm();
        var className = (this.props.theme == "true") ? "Dark" : "Light";
        return (<PopUpWindow theme={this.props.theme} style={{maxHeight:650}}>
            <div className={'popupWrapper' + className} id="AutokUpdate">
                <div  className={"popupHeader" + className} >
                    <Row>
                        <Col></Col>
                        <Col style={{textAlign: 'center'}}>{lang.getTitleBold('AutokView')}</Col>
                        <Col style={{textAlign: 'right'}}>
                        <Button className={'btn-sm'} variant="danger" onClick={this.closeForm.bind(this)}>{lang.getTitle('close')}</Button>
                        </Col>
                    </Row>
                </div>
                <div  className={"popupBody" + className} >{form}</div>
                <div  className={"popupFooter" + className} >
                    <Row>
                        <Col>
                        <div style={{whiteSpace: 'break-spaces'}}>
                            {this.msg} 
                        </div>
        
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <Button className={'btn-sm'} id={'save'} onClick={this.closeForm.bind(this)} variant="success" style={{marginTop: '5px'}}>{lang.getTitle('close')}</Button>&nbsp;&nbsp;&nbsp;      
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{minHeight: '10px'}}>
        
                        </Col>
                    </Row>
        
                </div>
            </div>
        </PopUpWindow>);
    }
}

export default AutokView;

